module.exports = __webpack_public_path__ + "img/Girl_010022.ae77eb39.png";